import { defaultDashboardWidgets, registry } from "./dashboardRegistry";

export const dashboardTypes = [
  {
    id: "overview",
    label: "Overview",
    title: "Dashboard",
    icon: "bx-home-alt",
    description: "An overview of your inspection program.",
    motto: "Quality. Insight. Confidence.",
  },
  {
    id: "reviews",
    label: "Inspections",
    title: "Inspections",
    icon: "bx-check-shield",
    description:
      "Track inspection progress, manage review assignments, and ensure timely completion.",
    motto: "Thorough Reviews. Stronger Quality.",
  },
  {
    id: "my-work",
    label: "My Work",
    title: "My Work",
    icon: "bx-user",
    description: "Your assigned work, upcoming deadlines and recent activity.",
    motto: "Focus Today. Stronger Reviews Tomorrow.",
  },
  {
    id: "resources",
    label: "Resources",
    title: "Resources",
    icon: "bx-group",
    description:
      "Resource allocation and team assignments across your inspection cycle.",
    motto: "Quality Today. A Stronger Profession Tomorrow.",
  },
];
const presets = {
  engagements: [
    "engagement-kpis",
    "engagement-progress-design",
    "engagement-risk-design",
    "engagement-cycle-design",
    "engagement-trend-design",
    "engagement-client-design",
    "key-deadlines-design",
    "engagement-review-type-design",
    "open-queries-design",
    "recent-activity-design",
  ],
  reviews: [
    "review-filters",
    "reviews-kpis",
    "review-status-design",
    "review-types-design",
    "reviewers-design",
    "review-trend-design",
    "review-deadlines-design",
    "review-activity-design",
  ],
  "my-work": [
    "work-kpis",
    "assigned-reviews-design",
    "my-calendar-design",
    "work-status-design",
    "work-deadlines-design",
    "my-progress-design",
    "dashboard-quote",
  ],
};
export const dashboardDefaults = (view = "overview") =>
  JSON.parse(
    JSON.stringify(
      presets[view]
        ? presets[view].map((type, sortOrder) => ({
            id: `${view}-${type}`,
            type,
            size: registry[type].defaultSize,
            sortOrder,
            configuration: registry[type].defaultConfiguration,
          }))
        : defaultDashboardWidgets
    )
  );
